import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Loner} from "../../Loner";

/**
 * Created by Jerker Nord on 2022-11-23.
 */

export class LonerInitialWinPresentation implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        if(Loner.model.brokeBank == false || (Loner.model.brokeBank == true && Loner.model.isNaturalMaxWin == true)) {
            return (Loner.model.gameData.accumulatedRoundWin > 0);
        } else {
            Loner.bigWinPresentation.initialWinDone = true;
            Loner.idleNormal.initialWinDone = true;
            return false;
        }
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._mainTL = gsap.timeline({onComplete : () => this.complete()});
        const tl:gsap.core.Timeline = Loner.initialWinView.getInitialWinAnimation().pause();
        let initialWinAnimDurr:number = tl.duration();
        this._mainTL.add(() => {
            tl.play();
        }, "+=0.2");
        if(Loner.model.winRatio >= 15) {
            this._mainTL.add(gsap.timeline({delay : 0.5}));
            this._mainTL.add(() => {
                Loner.bigWinPresentation.initialWinDone = true;
                Loner.idleNormal.initialWinDone = true;
            });
        }
        this._mainTL.to(this, {duration : initialWinAnimDurr});
    }

    private complete():void {
        this._controller.finish();
    }
}